<template>
  <PageBase class="dashboard-view">
    <header class="dashboard-view__header">
      <h1 class="dashboard-view__title">{{ $t('GENERAL.DETAILED_VIEW') }}</h1>
    </header>
    <SkeletonPlaceholder v-if="isLoading" />
    <section v-else class="dashboard-view__content">
      <TagsList v-if="isMobile" :items="tags" />

      <ColumnsList :items="columns" />
    </section>
    <Portal v-if="isCreateNoteModalVisible" to="root">
      <CreateNoteModal />
    </Portal>
    <Portal v-if="expandedDeal" to="root">
      <DealCardExpanded />
    </Portal>
    <Portal v-if="isExpandedDealLoading" to="root">
      <div class="dashboard-view__expanded-deal-loading">
        <HdLoadingSpinner />
      </div>
    </Portal>
  </PageBase>
</template>

<script>
import { OnResizeService } from 'homeday-blocks';
import PageBase from '@/layout/PageBase.vue';
import TagsList from '@/components/dashboard/TagsList.vue';
import ColumnsList from '@/components/dashboard/ColumnsList.vue';
import SkeletonPlaceholder from '@/components/dashboard/SkeletonPlaceholder.vue';
import CreateNoteModal from '@/components/dashboard/CreateNoteModal.vue';
import DealCardExpanded from '@/components/dashboard/DealCardExpanded.vue';
import HdLoadingSpinner from '@/components/HdLoadingSpinner.vue';
import { isMobile } from '@/services/breakpoints';
import { ACTION, GETTER } from '@/store/CONSTANTS';

export default {
  name: 'DashboardView',
  components: {
    PageBase,
    TagsList,
    ColumnsList,
    CreateNoteModal,
    DealCardExpanded,
    HdLoadingSpinner,
    SkeletonPlaceholder,
  },
  data() {
    return {
      isMobile: isMobile(),
    };
  },
  computed: {
    tags() {
      return this.$store.getters[GETTER.DASHBOARD.TAGS];
    },
    columns() {
      return this.$store.getters[GETTER.DASHBOARD.COLUMNS];
    },
    expandedDeal() {
      return this.$store.getters[GETTER.DASHBOARD.EXPANDED_DEAL];
    },
    isLoading() {
      return this.$store.getters[GETTER.DASHBOARD.IS_LOADING];
    },
    hasError() {
      return this.$store.getters[GETTER.DASHBOARD.HAS_ERROR];
    },
    error() {
      return this.$store.getters[GETTER.DASHBOARD.ERROR];
    },
    isExpandedDealLoading() {
      return this.$store.getters[GETTER.DASHBOARD.IS_EXPANDED_DEAL_LOADING];
    },
    isCreateNoteModalVisible() {
      return this.$store.getters[GETTER.DASHBOARD.CREATE_NOTE_MODAL_OPTIONS].isVisible;
    },
  },
  watch: {
    expandedDeal(expandedDeal) {
      if (expandedDeal) {
        this.freezeScrolling();
      } else {
        this.unfreezeScrolling();
      }
    },
  },
  async created() {
    await this.$store.dispatch(ACTION.DASHBOARD.FETCH_DASHBOARD);
  },
  mounted() {
    this.addListeners();
  },
  beforeDestroy() {
    this.removeListeners();
    this.unfreezeScrolling();
  },
  methods: {
    addListeners() {
      OnResizeService.onThrottled(this.setIsMobile);
    },
    removeListeners() {
      OnResizeService.offThrottled(this.setIsMobile);
    },
    setIsMobile() {
      this.isMobile = isMobile();
    },
    freezeScrolling() {
      document.body.style.overflow = 'hidden';
    },
    unfreezeScrolling() {
      document.body.style.overflow = 'auto';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.dashboard-view {
  ::v-deep .page-container {
    margin: 0;
    max-width: unset;

    @include for('desktop') {
      padding: 0 $sp-m;
    }
  }

  &__header {
    padding: 0 $sp-s;
  }

  &__content {
    padding: 0 0 0 $sp-s;
    margin-right: (-$sp-s);

    @include for('tablet') {
      margin-right: (-$sp-m);
    }
  }

  &__title {
    @include font('DS-200');

    @include for('tablet') {
      @include font('DS-400');
    }
  }

  &__header {
    margin-top: $sp-m;
    margin-bottom: $sp-m + $sp-s;

    @include for('tablet') {
      margin-top: $sp-m + $sp-s;
      margin-bottom: $sp-l + $sp-s;
    }
  }

  &__expanded-deal-loading {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    z-index: 30;
    background-color: rgba(0, 0, 0, 0.3);
  }
}
</style>
